import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const Monthlyincome = ({ onTotalAmountChange }) => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const navigate = useNavigate();

    const [fetchedData, setFetchedData] = useState([]);
    const [damages, setDamages] = useState([]);
    const [fetchedPaymentData, setFetchedPaymentData] = useState([]);
    const [fetchedAllPaymentData, setFetchedAllPaymentData] = useState([]);

    {/**useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        }
    }, [token]);
    
    useEffect(() => {
        const fetchProfile = async () => {
            if (!token) return; // Exit if no token
    
            try {
                const response = await axios.get('https://admin.bizstor.lk/public/api/profile', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUser(response.data);
            } catch (error) {
                console.log('');
            }
        };
    
        fetchProfile();
    }, [token]);*/}

    useEffect(() => {
        const fetchProfile = async () => {
          const token = localStorage.getItem("token");
    
          if (!token) {
            navigate("/"); // Redirect if no token
            return;
          }
    
          try {
            const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
              headers: { Authorization: `Bearer ${token}` },
            });
            setUser(response.data);
          } catch (error) {
            if (error.response && error.response.status === 401) {
              localStorage.removeItem("token");
              navigate("/"); // Redirect on 401 error
            }
          }
        };
    
        fetchProfile();
      }, []);

    useEffect(() => {
        if (user.id) {
            fetchData();
            fetchDamages();
            fetchPaymentData();
            fetchPayments();
        }
    }, [user.id]);

    const fetchData = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-data');
            if (user.id) {
                const Order = response.data.filter(order =>
                    order.usertoken.toLowerCase() === user.id.toString().toLowerCase() 
                    //&& order.term === 'due on receipt'
                );
                setFetchedData(Order);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchPaymentData = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-data');
            if (user.id) {
                const Order = response.data.filter(order =>
                    order.usertoken.toLowerCase() === user.id.toString().toLowerCase() &&
                    order.term !== 'due on receipt'
                );
                setFetchedPaymentData(Order);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchPayments = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-payment-data')
            if (user.id) {
                const Payment = response.data.filter(payment =>
                    payment.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
                setFetchedAllPaymentData(Payment);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    const fetchDamages = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-damage-data');
            if (user.id) {
                const Damage = response.data.filter(damage =>
                    damage.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
                setDamages(Damage);
            }
        } catch (error) {
            console.error('Error fetching damage data:', error);
        }
    };

    useEffect(() => {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth(); // 0-11
        const currentYear = currentDate.getFullYear();

        let total = 0;
        fetchedData.forEach(order => {
            let orderTotal = 0;

            const invoiceDate = new Date(order.invoicedate);
            if (
                invoiceDate.getMonth() === currentMonth &&
                invoiceDate.getFullYear() === currentYear
            ) {
                order.items.forEach(item => {
                    const itemPrice = Number(item.price);
                    const itemTax = Number(item.tax) || 0;
                    const itemTotal = itemPrice + (itemPrice * (itemTax / 100)); // Adding item-specific tax
                    orderTotal += itemTotal;
                });

                const discountPercentage = order.discount || 0;
                const discountAmount = (orderTotal * discountPercentage) / 100; // Calculate discount amount
                orderTotal -= discountAmount; // Apply discount

                total += orderTotal;
            }
        });

        let totalpay = 0;
        fetchedPaymentData.forEach(order => {
            let orderTotal = 0;

            const invoiceDate = new Date(order.invoicedate);
            if (
                invoiceDate.getMonth() === currentMonth &&
                invoiceDate.getFullYear() === currentYear
            ) {
                orderTotal += Number(order.payamount) || 0; // Add payamount directly

                totalpay += orderTotal;
            }
        });

        let totalallpayment = 0;

        fetchedAllPaymentData.forEach(payment => {
            const invoiceDate = new Date(payment.date);
            if (
                invoiceDate.getMonth() === currentMonth &&
                invoiceDate.getFullYear() === currentYear
            ) {
                totalallpayment += Number(payment.amount) || 0; // Add amount directly
            }
        });



        const { damageTotalPrice } = damages.reduce(
            (totals, damage) => {
                damage.items.forEach(item => {
                    if (damage.type === 'money back') {
                        totals.damageTotalPrice += Number(item.price);
                    }
                });
                return totals;
            },
            { damageTotalPrice: 0 }
        );

        const replaceCount = damages.reduce(
            (count, damage) => {
                damage.items.forEach(item => {
                    if (damage.type === 'replace') {
                        count += Number(item.quantity);
                    }
                });
                return count;
            },
            0
        );

        const finalTotal = total - damageTotalPrice ; // Deduct money back from total + totalpay + totalallpayment
        if (onTotalAmountChange) {
            onTotalAmountChange(finalTotal);
        }

        {/**console.log('Replace Count:', replaceCount);*/ }
    }, [fetchedData, damages, onTotalAmountChange]);

    return null; 
};

export default Monthlyincome;
